<template>
  <div class="mr-1 mr-md-5 d-flex justify-content-center align-items-center">
    <div class="mr-3">
      <b-img-lazy blank-src="/static/blank_profile.jpg" :src="imgsrc(track.image)" :alt="track.name" width="50px" class="magid-image rounded-circle" />
    </div>
    <div class="d-lg-inline-block lecturer-info">
      <h5 class="mb-0 font-weight-bold">{{ track.trackName }}</h5>
      <span>by {{ track.lecturerName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['track'],
  methods: {
    imgsrc: function (image) {
      return image || '/static/blank_profile.jpg';
    },
  },
};
</script>

<style>
</style>